/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 4/28/22, 1:27 PM
 *
 */

import { memberSlice } from './stores/memberSlice';

export const memberReducer = memberSlice.reducer;
export const { setRole, setStartDate, setEndDate, setUser, setMember, remove } =
  memberSlice.actions;
export { default as MemberListPage } from './pages/MemberListPage';
